<template>
  <div class="teachGroup">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-input class="searchInput" v-model="joinPhone" placeholder="请输入手机号" maxlength="11"></el-input>
        </el-form-item>
        <el-button type="primary" @click="activityList()">查询</el-button>
      </el-form>
    </div>
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="jump()">{{$t('lang.btn_backActivity')}}</el-button>
      </div>
      <el-table :data="tableData" class="wid100" :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" v-if="this.seeActivityManagementcheckbox"></el-table-column>
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <el-table-column prop="sch" label="学校名称"></el-table-column>
        <el-table-column prop="joinPhone" label="团长手机号"></el-table-column>
        <el-table-column :label="$t('lang.lab_operation')" prop="operation"
          :width="require('@/config/enum').opr_width3">
          <template slot-scope="scope">
            <el-button @click="joinList(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
  </div>
</template>

<script>
  /**
   *@ClassName:teachGroup
   *@Description:活动管理详情
   *@author:刘彦辰
   *@Copyright:格众科技
   *@date:2020-02-21
   */
  export default {
    data() {
      return {
        multipleSelection: [],
        pageCount: 0,
        pageNum: 1,
        pageSize: 10,
        tableData: [],
        id: '',
        seeActivityManagementcheckbox: require('@/config/enum').seeActivityManagementcheckbox, // 是否隐藏复选框
        joinPhone: ''
      }
    },
    created() {
      this.id = this.$route.query.id
      this.activityList()
    },
    methods: {
      // 列表隔行变色
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      // CHECKBOX
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      // 活动参团详情列表
      activityList() {
        let loading = this.$loading()
        this.$get(
          `/activitySignByGroupId?isLeader=1&pageSize=${this.pageSize}&pageNo=${this.pageNum}&activityId=${this.id}&joinPhone=${this.joinPhone}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 点击换页
      handleCurrentChange(val) {
        this.pageNum = val
        this.activityList()
      },
      // 返回按钮
      jump() {
        this.$router.push({
          name: 'teachGroupList'
        })
      },
      // 点击更改每页容量
      handleSizeChange(val) {
        this.pageNum = 1
        this.pageSize = val
        this.activityList()
      },
      // 查看教育活动团里人员list
      joinList(row) {
        this.$router.push({
          name: 'joinManagement',
          query: {
            activityId: row.activityId,
            groupId: row.groupId,
          }
        })
      },
    }
  }
</script>

<style>

</style>